export enum SocialLinksEnum {
  FACEBOOK = 'facebook',
  INSTAGRAM = 'instagram',
  LINKEDIN = 'linkedin',
  TWITTER = 'twitter',
  GITHUB = 'github',
  YOUTUBE = 'youtube',
  BLUESKY = 'bluesky',
  THREADS = 'threads',
  TIKTOK = 'tiktok',
}
